import { useTranslation } from 'react-i18next';
import { Icon, type IconName } from '../../components/Icon';
import { MONOGRAPH_VIEWS, monographViewPreference, type MonographView } from '../../preferences/displayPreferences';
import { usePreference } from '../../preferences/storedPreference';

const VIEW_ICONS: Record<MonographView, IconName> = { cards: 'gridView', sheet: 'tableRows' };

/**
 * #928 (epic #934): Cards | Sheet. Choosing a view shows it and remembers the choice, so every
 * Monograph opens that way next time -- the same preference the account menu's Display sets.
 */
export function MonographViewSwitch() {
  const { t } = useTranslation();
  const view = usePreference(monographViewPreference);
  return (
    <div className="monograph-view-switch" role="group" aria-label={t('monograph.view.label')}>
      {MONOGRAPH_VIEWS.map((option) => (
        <button
          key={option}
          type="button"
          aria-pressed={view === option}
          aria-label={t(`monograph.view.${option}`)}
          title={t(`monograph.view.${option}`)}
          className={view === option ? 'active' : ''}
          onClick={() => monographViewPreference.set(option)}
        >
          <Icon name={VIEW_ICONS[option]} size="1.1rem" />
          <span className="monograph-view-switch-label">{t(`monograph.view.${option}`)}</span>
        </button>
      ))}
    </div>
  );
}

/** The view a Monograph should open in. */
export function useMonographView(): MonographView {
  return usePreference(monographViewPreference);
}
